(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Tablet', Tablet);

    Tablet.$inject = ['$resource'];

    function Tablet ($resource) {
        var resourceUrl =  'api/tablets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
